import CheckBox from "./checkbox";

export default CheckBox;
